import { useMemo } from 'react';

export function useAllowedImgExtensions(extensions: string[]) {
  const allowedImgExtensions = useMemo(() => {
    return {
      allowedExtensions: extensions,
      allowedExtensionsText:
        extensions.length > 1
          ? extensions.slice(0, -1).join(', ') + ' ou ' + extensions.slice(-1)
          : extensions[0],
    };
  }, []);
  return { allowedImgExtensions };
}
